export default function getUrls(guid?: string) {
    return {
        list: '/magazines',
        ...(guid
            ? {
                  edit: `/magazines/edit/${guid}`,
                  addIssue: `/magazine-issue/add/${guid}`,
              }
            : {}),
    }
}
